 
import { createContext, useContext } from 'react'

import { ToolWidgetType, WidgetNode } from '@/shared/components/Mosaic/models/widgetType'

export type WidgetToolbarContextType = {
  widgets: WidgetNode[]
  moveWidgetToToolbar: (widget: ToolWidgetType, idx: number) => void
  moveWidgetToWindow: (idx: number) => void
  moveWidgetAroundToolbar: (fromIndex: number, toIndex: number) => void
  hideWidget: (widget: ToolWidgetType, idx?: number) => void
  unHideWidget: (widget: ToolWidgetType) => void
  isWidgetSettingsOpen: boolean
  setWidgetSettingsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const WidgetToolbarContext = createContext<WidgetToolbarContextType>({
  widgets: [],
  moveWidgetToToolbar: () => {},
  moveWidgetToWindow: () => {},
  moveWidgetAroundToolbar: () => {},
  hideWidget: () => {},
  unHideWidget: () => {},
  isWidgetSettingsOpen: false,
  setWidgetSettingsOpen: () => {},
})

export const useWidgetToolbarContext = () => {
  const context = useContext(WidgetToolbarContext)

  if (context === undefined) {
    throw new Error(
      'useWidgetToolbarContext must be used within a WidgetToolbarContext.Provider',
    )
  }

  return context
}